import { useEffect, FunctionComponent, useState } from 'react';
import useFetchBillPayTransaction from '@/hooks/useApi/useFetchBillPayTransaction';
import BillPayInfo from './BillPayInfo';

type TransactionProps = {
  TransactionID: string;
};
type FC = FunctionComponent<TransactionProps>;

const BillPayContainer: FC = (props: TransactionProps) => {
  const { TransactionID } = props;
  const { fetchBillPayTransaction, details } = useFetchBillPayTransaction();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();

  useEffect(() => {
    fetchBillPayTransaction({
      TransactionID: TransactionID,
    });
  }, [currentTransactionId]);

  useEffect(() => {
    if (currentTransactionId !== TransactionID) {
      setCurrentTransactionId(TransactionID);
    }
  }, [TransactionID, currentTransactionId]);

  return <div>{details && <BillPayInfo transaction={details} />}</div>;
};

export default BillPayContainer;
